import Vue from 'vue';
import Router from 'vue-router'
import routes from '@/router/routers';
import {
    localToken
} from "@/libs/util";
import {
  initRouter
} from '@/libs/router-util'

Vue.use(Router)
const router = new Router({
  routes,
  mode: 'history'
})
const LOGIN_PAGE_NAME = 'login'
const INDEX_NAME = 'index'
    //前置操作 检测用户是否登录等 未登录通过oauth页面进行登录
// router.beforeEach((to, from, next) => {
//     const token = localToken.getToken()
//     const query = to.query
//     debugger
//     if( !token ){
//         // const openId = localToken.getOpenId();
//         if(query.openId && to.name !== INDEX_NAME){
//         // if(query.openId && to.name !== LOGIN_PAGE_NAME&& to.name !== INDEX_NAME){
//           if(query.openId){
//             localToken.setIsBind(query.isBind);
//             localToken.setOpenId(query.openId);
//             localToken.setTenantIds(query.tenantId);
//             localToken.setTenantNames(query.tenantName);
//           }
//           next({
//               name: INDEX_NAME,
//               query: {openId: query.openId}
//           })
//         } else if (!query.openId && to.name !== LOGIN_PAGE_NAME ){
//           next({
//               name: LOGIN_PAGE_NAME // 跳转到登录页
//           })
//         } else if (to.name === LOGIN_PAGE_NAME){
//           next() // 有权限，可访问
//         }
//          else {
//           initRouter() // 登录页刷新重新获取,确保路由跳转前即beforeEach获取到动态路由表
//           next() // 有权限，可访问
//         }
//     } else {
//         if (to.name === LOGIN_PAGE_NAME || to.name === INDEX_NAME || typeof to.name === "undefined"|| to.path == null) {
//           // 已登录且要跳转的页面是登录页面、租户页面、手机绑定页面
//           next({
//               name: 'main' // 跳转到main页
//           })
//         } else if (to.name !== LOGIN_PAGE_NAME&& to.name !== INDEX_NAME) {
//           // 已登录且要跳转的页面不是登录页面、租户页面、手机绑定页面
//           next()
//         } else{
//           // initRouter() // 登录页刷新重新获取,确保路由跳转前即beforeEach获取到动态路由表
//           next() // 有权限，可访问
//         }  
//     }
// });

router.beforeEach((to, from, next) => {
    const token = localToken.getToken()
    const query = to.query
    if( token!="" ){
        
        // if(query.openId && to.name !== INDEX_NAME){
        // // if(query.openId && to.name !== LOGIN_PAGE_NAME&& to.name !== INDEX_NAME){
        //   if(query.openId){
        //     localToken.setIsBind(query.isBind);
        //     localToken.setOpenId(query.openId);
        //     localToken.setTenantIds(query.tenantId);
        //     localToken.setTenantNames(query.tenantName);
        //   }
        //   next({
        //       name: INDEX_NAME,
        //       query: {openId: query.openId}
        //   })
        // } else if (!query.openId && to.name !== LOGIN_PAGE_NAME ){
        //   next({
        //       name: LOGIN_PAGE_NAME // 跳转到登录页
        //   })
        // } else if (to.name === LOGIN_PAGE_NAME){
        //   next() // 有权限，可访问
        // }
        //  else {
        //   initRouter() // 登录页刷新重新获取,确保路由跳转前即beforeEach获取到动态路由表
        //   next() // 有权限，可访问
        // }
        if(to.name=== INDEX_NAME|| to.name===LOGIN_PAGE_NAME)
        {
          next({
            name: 'main' // 跳转到main页
        })
        }
        else
        {
          next() // 有权限，可访问
        }
    } else {
        if (to.name !== LOGIN_PAGE_NAME ) {
          if(to.name!==INDEX_NAME)
          {
            if(to.name==undefined)
            {
              next({
                name: INDEX_NAME 
            })
            }
            else
            {
          next({
              name: LOGIN_PAGE_NAME // 跳转到登录页
          })
        }
        }else{
            // initRouter() // 登录页刷新重新获取,确保路由跳转前即beforeEach获取到动态路由表
          next() // 有权限，可访问
        }  
          
        }
        else
        {
          // initRouter() // 登录页刷新重新获取,确保路由跳转前即beforeEach获取到动态路由表
          next()
        } 
    }
});

router.afterEach(to => {
  window.scrollTo(0, 0)
})
export default router


// WEBPACK FOOTER //
// ./src/router/index.js